import request from '@/utils/request'

// 管理员登录
export function adminLogin(data) {
  return request({
    url: '/api/admin/login',
    method: 'post',
    data
  })
}

// 获取管理员信息
export function getAdminProfile() {
  return request({
    url: '/api/admin/profile',
    method: 'get'
  })
}

// 获取所有用户
export function getUsers() {
  return request({
    url: '/api/admin/users',
    method: 'get'
  })
}

// 创建用户
export function createUser(data) {
  return request({
    url: '/api/admin/users',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(id, data) {
  return request({
    url: `/api/admin/users/${id}`,
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/api/admin/users/${id}`,
    method: 'delete'
  })
}